// store/modules/lastUpdate.module.ts
import { Module, VuexModule, Mutation } from "vuex-module-decorators";

@Module({ namespaced: true, name: "lastUpdate" })
export default class LastUpdateModule extends VuexModule {
  public lastUpdateDate = "";

  @Mutation
  public setLastUpdateDate(date: string): void {
    this.lastUpdateDate = date;
  }

  get getLastUpdateDate(): string {
    return this.lastUpdateDate;
  }
}